import React from "react";

const FloatingWhatsApp = () => {
    return (
        <a
            href="https://wa.me/918897388513"
            target="_blank"
            rel="noopener noreferrer"
            className="floating-whatsapp"
            aria-label="Chat on WhatsApp"
        >
            <i className="fab fa-whatsapp"></i>
        </a>
    );
};

export default FloatingWhatsApp;
